module.exports = __webpack_public_path__ + "static/media/phone.321521b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Sweeping/phone.mp4
// module id = 8Of5
// module chunks = 1